import { useParams } from "react-router-dom";
import { FacilityEmployeesTable } from "./_FacilityEmployeesTable";

export default function FacilityPeopleEmployeesPage() {
  const { facilityId } = useParams();

  return <FacilityEmployeesTable facilityId={facilityId!} />;
}
